import React, { createContext, useState, useContext } from 'react';

const GuideContext = createContext();

export const GuideProvider = ({ children }) => {
  const [showGuide, setShowGuide] = useState(false);
  const [currentPage, setCurrentPage] = useState('');

  const startGuide = (page) => {
    setCurrentPage(page);
    setShowGuide(true);
  };

  const stopGuide = () => {
    setShowGuide(false);
  };

  return (
    <GuideContext.Provider value={{ 
      showGuide, 
      currentPage, 
      startGuide, 
      stopGuide 
    }}>
      {children}
    </GuideContext.Provider>
  );
};

export const useGuide = () => useContext(GuideContext); 